import type { CtxProductVariant } from '@containex/portal-backend-api-client';
import { DepotType, ProductType } from '@containex/portal-backend-dto';
import { VIRTUAL_DEPOT } from '@containex/portal-business-logic';
import { AVAILABLE_NOW_EX_DEPOT, AVAILABLE_NOW_EX_FACTORY, ORDERED_EX_FACTORY } from '@containex/common-utils';

export function filterProductVariantForProvisionType(
    variant: CtxProductVariant,
    countryCode: string | undefined,
    isRental: boolean,
    productType: ProductType | undefined | null = ProductType.CONTAINER_PRODUCT
): boolean {
    if (isRental) {
        return variant.depotQuantity.depot.type === DepotType.Rental;
    }

    // variants for serial number products are not filtered out, if it's not a similar product
    if (productType === ProductType.SERIAL_NUMBER_PRODUCT) {
        return true;
    }

    return (
        variant.depotQuantity.depot.type === DepotType.ProductionSite ||
        variant.depotQuantity.depot.address.country_code?.toLowerCase() === countryCode?.toLowerCase()
    );
}

export function filterProductVariantForAvailableNowTypes(
    variant: CtxProductVariant,
    selectedAvailabilityTypes: string[]
): boolean {
    const availableExFactory = selectedAvailabilityTypes.includes(AVAILABLE_NOW_EX_FACTORY);
    const availableExDepot = selectedAvailabilityTypes.includes(AVAILABLE_NOW_EX_DEPOT);
    const availableOrdered = selectedAvailabilityTypes.includes(ORDERED_EX_FACTORY);
    const isVirtualDepot = variant.depotQuantity.depot.depot_id === VIRTUAL_DEPOT;

    // If the variant has to be available-now: we filter depending on the type selected: ex works/ex depot
    if ((availableExFactory || availableExDepot) && variant.depotQuantity.quantity_available > 0) {
        return isVirtualDepot ? availableExFactory : availableExDepot;
    }
    // Otherwise we check if the variant has to be back-ordered
    return availableOrdered && isVirtualDepot && variant.depotQuantity.quantity_ordered > 0;
}
